import { callApi } from "@src/utils/api-client";
import { getFailureTypeForHttpStatus } from "@src/utils/failure-taxonomy";
import ClientLogsService from "./client-logs.service";
import { buildReferrerTeamsConfig } from "./configs/referrer-teams.config";

export interface ReferrerTeam {
  id: string;
  name: string;
}

interface ReferrerTeamBackendResponse {
  referrerTeamId: string;
  referrerTeamName: string;
}

export const fetchReferrerTeams = async (partner_id: string, userUuid?: string) => {
  try {
    const { data, response } = await callApi(buildReferrerTeamsConfig(partner_id, userUuid));

    if (!response.ok) {
      ClientLogsService.logError(
        "system",
        "referrer-teams.service.fetchReferrerTeams",
        "Failed to fetch referrer teams data",
        new Error(`API responded with status ${response.status} : ${response.statusText}`),
        {
          errorType: getFailureTypeForHttpStatus(response.status),
          dependencyName: "ReferrerTeamsAPI",
          functionName: "fetchReferrerTeams",
        },
      );

      return { error: `Error fetching referrer teams: ${response.statusText}` };
    }

    const referrerTeams = (data as { referrer_teams?: ReferrerTeamBackendResponse[] })
      ?.referrer_teams;

    return Array.isArray(referrerTeams)
      ? referrerTeams.map((referrerTeam) => ({
          id: referrerTeam.referrerTeamId,
          name: referrerTeam.referrerTeamName,
        }))
      : [];
  } catch (error: any) {
    ClientLogsService.logError(
      "system",
      "referrer-teams.service.fetchReferrerTeams",
      "Error fetching referrer teams data",
      error instanceof Error ? error : new Error("Unknown error"),
      {
        errorType: "DependencyFailure",
        dependencyName: "ReferrerTeamsAPI",
        functionName: "fetchReferrerTeams",
      },
    );

    return { error: error.message || "Failed to fetch referrer teams" };
  }
};
